import { render, staticRenderFns } from "./NationalTrademarkHistoryForm.vue?vue&type=template&id=545d1943&"
import script from "./NationalTrademarkHistoryForm.vue?vue&type=script&lang=js&"
export * from "./NationalTrademarkHistoryForm.vue?vue&type=script&lang=js&"
import style0 from "./NationalTrademarkHistoryForm.vue?vue&type=style&index=0&id=545d1943&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports